export default __webpack_public_path__ + "static/media/Axe_6.2b946504.png";